import * as ACTION_TYPES from "../actions/Main_types";

export default function reducer(state, action) {
  switch (action.type) {
    case ACTION_TYPES.LOGIN:
      return { ...state, isLoggingIn: true };
    case ACTION_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        acceptedDisclosures: !action.agency,
        isAuthenticated: true,
        loginError: null,
        isLoggingIn: false,
        agency: action.agency,
        phoneVerified: action.phoneVerified,
        userType: action.userType,
        questionnaire: action.questionnaire,
        sentimentQuestionnaire: action.sentimentQuestionnaire,
        agencyLinked: action.agencyLinked,
      };
    case ACTION_TYPES.ACCEPT_DISCLOSURES:
      return {
        ...state,
        acceptedDisclosures: true,
      };
    case ACTION_TYPES.PHONE_VERIFIED:
      return {
        ...state,
        phoneVerified: true,
      };
    case ACTION_TYPES.QUESTIONNAIRE:
      return {
        ...state,
        questionnaire: true,
      };
    case ACTION_TYPES.SENTIMENT_QUESTIONNAIRE:
      return {
        ...state,
        sentimentQuestionnaire: true,
      };
    case ACTION_TYPES.AGENCY_LINKED:
      return {
        ...state,
        agencyLinked: true,
      };
    case ACTION_TYPES.SET_REFCODE:
      return {
        ...state,
        refCode: action.payload,
      };
    case ACTION_TYPES.LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        loginError: action.payload,
        isLoggingIn: false,
      };
    case ACTION_TYPES.SET_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };
    case ACTION_TYPES.SET_AGENCY_DETAILS:
      return {
        ...state,
        agencyDetails: {
          ...state.agencyDetails,
          ...action.payload,
        },
      };
    case ACTION_TYPES.SET_AVATAR:
      return {
        ...state,
        avatar: action.payload,
      };
    case ACTION_TYPES.SET_APPCONFIG:
      return {
        ...state,
        appConfig: action.payload,
      };
    case ACTION_TYPES.SET_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      };
    case ACTION_TYPES.LOGOUT:
      window.location = "/";
      return;
    default:
      return state;
  }
}
